import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Input, Button, Form, Select } from 'antd';

const SystemParameter = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache, translationCache]);

  const translation = (keyword) => {
    return props.translationCache && props.translationCache[keyword] ? props.translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };

  return (
    <div style={{}}>
      <Form
        {...formItemLayout}
        layout="horizontal"
        name={translation('HeaderNumber_current')}
        style={{ margin: '19px', padding: '30px' }}
      >
        <Form.Item label={translation('HD')}>
          <Select style={{ width: 440 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label={translation('Temperature Alarm Upper Limit')}>
          <Input style={{ width: '440px' }} />
        </Form.Item>
        <Form.Item label={translation('Temperature Alarm Lower Limit')}>
          <Input style={{ width: '440px' }} />
        </Form.Item>

        <Form.Item label={translation('Zero Coefficient')}>
          <Input style={{ width: '220px' }} />
          <Input style={{ width: '220px' }} />
        </Form.Item>
        <Form.Item label={translation('Temperature Coefficient-b0')}>
          <Input style={{ width: '220px' }} />
          <Input style={{ width: '220px' }} />
        </Form.Item>
        <Form.Item label={translation('Temperature Coefficient-b1')}>
          <Input style={{ width: '220px' }} />
          <Input style={{ width: '220px' }} />
        </Form.Item>
        <Form.Item label={translation('Temperature Coefficient-b2')}>
          <Input style={{ width: '220px' }} />
          <Input style={{ width: '220px' }} />
        </Form.Item>
        <Form.Item {...buttonItemLayout}>
          <Button type="primary">{translation('Write to KB-30')}</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(SystemParameter);
